import React from 'react';
import {
    Box,
    Typography,
    Container,
    Paper,
    Divider,
    Link
} from '@mui/material';
import { config_strings }  from './config/config';

const PrivacyPolicy = () => {
    const { legal } = config_strings;
    const { privacy_policy, company_info } = legal;

    return (
        <Container maxWidth="md" sx={{ py: 4 }}>
            <Paper elevation={1} sx={{ p: 4 }}>
                <Typography variant="h4" gutterBottom>
                    {privacy_policy.title}
                </Typography>
                
                <Typography variant="body2" color="text.secondary" gutterBottom>
                    Last updated: {privacy_policy.last_updated}
                </Typography>

                <Divider sx={{ my: 3 }} />

                <Box sx={{ '& > *': { mb: 3 } }}>
                    {Object.entries(privacy_policy.sections).map(([key, section]) => (
                        <Box key={key}>
                            <Typography variant="h6" gutterBottom>
                                {section.title}
                            </Typography>
                            <Typography 
                                variant="body2" 
                                paragraph
                                dangerouslySetInnerHTML={{ __html: section.content }}
                            />
                        </Box>
                    ))}

                    <Divider sx={{ my: 3 }} />

                    <Box sx={{ bgcolor: 'grey.50', p: 2, borderRadius: 1 }}>
                        <Typography variant="caption" color="text.secondary">
                            <strong>{company_info.name}</strong><br />
                            Company Number: {company_info.company_number}<br />
                            Registered Address: {company_info.registered_address}<br />
                            Incorporated: {company_info.incorporated_date}
                        </Typography>
                    </Box>
                </Box>
            </Paper>
        </Container>
    );
};

export default PrivacyPolicy;